import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f26cc050"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "map3D" }, null, -1))

import {
  onMounted, ref, watch, onBeforeUnmount, shallowRef,
} from 'vue';
import moment from 'moment';
import { useStore, } from 'vuex';
import CesiumViewer from '@/utils/cesium/index';
import { wmsUrl, } from '@/configs/mapConfig';
import Play from './components/play/index.vue';
import AQIRank from './components/AQIRank/index.vue';
import { defaultIndexName, } from '@/store/modules/layerConsole';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

// 初始化地图模块
const cesiumViewer = shallowRef<any>();

const rankVisiable = ref(true);

const changeVisable = () => {
  rankVisiable.value = false;
};

onMounted(() => {
  const dom = document.getElementById('map3D');

  cesiumViewer.value = new CesiumViewer('map3D');

  if (dom) {
    if (dom.childNodes[1]) {
      dom.removeChild(dom.childNodes[0]);
    }
  }

  cesiumViewer.value.addRegionBorder('990000000000');
  // 测试找事，提的需求
  cesiumViewer.value.camera.moveUp(350000);

  // cesiumViewer.value.addTestLayer('./static/data/test3D.png', extent);

  store.commit('layerConsole/setIndexName', defaultIndexName);
});

onBeforeUnmount(() => {
  cesiumViewer.value.clearDataSource();

  // cesiumViewer.value.destroy();

  cesiumViewer.value = null;
  const dom = document.getElementById('map3D');
  // 清除地图DOM元素

  if (dom) {
    if (dom.childNodes) {
      const { length, } = dom.childNodes;

      for (let i = 0; i < length; i++) {
        dom.removeChild(dom.childNodes[i]);
      }
    }
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(Play, { cesiumViewer: _unref(cesiumViewer) }, null, 8, ["cesiumViewer"])
  ], 64))
}
}

})